import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { getFullProduct, getProductDetails, placeOrder } from "../../state/api";
import state from "../../state/state";
import { getText, getTextFixed } from "../../state/translations";
import { Button } from "../button/button";
import { dialog } from "../dialog/dialog";
import { FinalizeConfigurationItem } from "./finalizeConfigurationItem";
import { FinalizeConfigurationSummary } from "./finalizeConfigurationSummary";
import "./finalizeConfiguration.scss";
import { Svg } from "../svg/svg";
import { getAsset } from "../../utils/utils";
import { shareDialog } from "../share/shareDialog";
import { Checkbox } from "../checkbox/checkbox";
import { find } from "../../state/data";
export class FinalizeConfiguration extends MithrilTsxComponent {
    articles = [];
    subs = [];
    oninit(v) {
        this.updateSelectedArticles();
        this.subs.push(state.on("quantity:change", () => this.updateSelectedArticles()));
        // load() restore article quantities silently (emit=false), re-sync once it settle
        this.subs.push(state.on("loaded", () => this.updateSelectedArticles()));
    }
    view(v) {
        return m("div", { className: "FinalizeConfiguration" },
            m("div", { className: "header" },
                m("div", { className: "info" },
                    m("button", { className: "back", onclick: () => v.attrs.onstep(0) },
                        m(Svg, { className: "icon", src: getAsset("icons/back-2.svg") }),
                        m("span", null, getTextFixed("PREV_BUTTON"))),
                    m("span", { className: "title" }, getTextFixed("COMPLETE_YOUR_CONFIGURATION")),
                    m("span", { className: "description" }, state.getSummary())),
                this.articles?.length > 0 &&
                    m("div", { className: "actions" },
                        m(Button, { className: `button-secondary pdf ${this.articles.length === 0 ? "-disabled" : ""}`, onclick: () => this.articles.length === 0 ? undefined : shareDialog(), disabled: this.articles.length === 0 },
                            m(Svg, { className: "icon", src: getAsset("icons/download-2.svg") }),
                            m("span", null, getTextFixed("DOWNLOAD_PDF"))),
                        m("button", { className: "share", type: "button", onclick: () => this.openShareUrlDialog() },
                            m(Svg, { className: "icon", src: getAsset("icons/share-3.svg") })))),
            m("div", { className: "content" },
                m("section", { className: "products" },
                    this.articles.length > 0
                        ? this.articles.map(article => m(FinalizeConfigurationItem, { article: article, ondelete: () => this.deleteArticle(article), onquantity: value => state.setQuantity(article.artCodeTSNL, value) }))
                        : m("div", { className: "empty" }, getTextFixed("NO_PRODUCTS_SELECTED")),
                    m("div", { className: "extra-options" },
                        m("div", { className: "buttons" },
                            m("button", { className: "button button-default", onclick: () => v.attrs.onstep(0) },
                                m(Svg, { className: "icon", src: getAsset("icons/back-2.svg") }),
                                m("span", null, getTextFixed(this.articles.length > 0 ? "SELECT_ANOTHER_PART" : "SELECT_A_PART")))),
                        m("span", { className: "title" }, getTextFixed("EXTRA_SERVICES")),
                        m("div", { className: "services" },
                            m("div", { className: "service" },
                                m(Checkbox, { checked: state.mobileTrackService, onchange: v => state.setMobileTrackService(v) }),
                                m("div", { className: "content" },
                                    m("div", { className: "title" },
                                        m(Svg, { className: "icon", src: getAsset("icons/tools.svg") }),
                                        m("span", null, getTextFixed("MOBILE_TRACK_SERVICE"))),
                                    m("p", { className: "description" }, getTextFixed("MOBILE_TRACK_SERVICE_DESCRIPTION")))),
                            m("div", { className: "service" },
                                m(Checkbox, { checked: state.returnOldProduct, onchange: v => state.setReturnOldProduct(v) }),
                                m("div", { className: "content" },
                                    m("div", { className: "title" },
                                        m(Svg, { className: "icon", src: getAsset("icons/retour.svg") }),
                                        m("span", null, getTextFixed("RETURN_OLD_PRODUCT"))),
                                    m("p", { className: "description" }, getTextFixed("RETURN_OLD_PRODUCT_DESCRIPTION"))))))),
                m(FinalizeConfigurationSummary, { articles: this.articles, onplaceorder: async () => {
                        await placeOrder(state);
                        m.redraw();
                    } })));
    }
    updateSelectedArticles() {
        this.articles = [];
        for (const art in state.articles) {
            const exists = find(art, state.products.filtered);
            if (!exists)
                continue;
            const item = {
                ...exists?.product ?? {},
                promise: (exists
                    ? getFullProduct(exists.product)
                    : getProductDetails(art))
                    .catch(() => {
                    // ignore errors, item will have only code as name and no price
                })
                    .then(full => {
                    if (full)
                        Object.assign(item, full);
                    // progress?.(item)
                    return item;
                })
                    .finally(() => {
                    m.redraw();
                })
            };
            const article = {
                artCodeTSNL: art,
                category: getText(exists?.category || item.category, undefined, exists?.category || item.category),
                qty: state.getQuantity(art),
                item
            };
            //   article.description ??= () => getProductName(article, full)
            this.articles.push(article);
        }
    }
    deleteArticle = async (art) => {
        let r = await dialog({
            className: "confirm-dialog",
            title: getTextFixed("CONFIRM_DELETE"),
            dismiss: false,
            closeIcon: true
        }, c => [
            m("p", null, getTextFixed("REMOVE_ARTICLE")),
            m("div", { className: "dialog-footer" },
                m(Button, { text: getTextFixed("NO_DELETE"), className: "button-ghost-default", onclick: () => c() }),
                m(Button, { text: getTextFixed("YES_DELETE"), className: "button-secondary", onclick: () => c("remove") }))
        ]).promise;
        if (r === "remove") {
            state.setQuantity(art.artCodeTSNL, 0);
            m.redraw();
        }
    };
    openShareUrlDialog = () => {
        const url = state.getURL();
        let copied = false;
        dialog({
            title: getTextFixed("SHARE_CONFIGURATION"),
            closeIcon: true,
            className: "share-url-dialog",
        }, close => {
            const copy = async () => {
                await navigator.clipboard.writeText(url);
                copied = true;
                m.redraw();
                setTimeout(() => {
                    copied = false;
                    m.redraw();
                }, 2000);
            };
            return m("div", { className: "share-url-content" },
                m("div", { className: "share-url-row" },
                    m("input", { className: "share-url-input", type: "text", readonly: true, value: url, onclick: (e) => e.target.select() }),
                    m("button", { className: `share-url-copy ${copied ? "copied" : ""}`, type: "button", onclick: copy }, copied ? getTextFixed("COPIED") : getTextFixed("COPY"))));
        });
    };
    onremove() {
        this.subs.forEach(sub => sub.off?.());
    }
}
